import { render, staticRenderFns } from "./CreateAreaManager.vue?vue&type=template&id=5cc85ed8&"
import script from "./CreateAreaManager.vue?vue&type=script&lang=js&"
export * from "./CreateAreaManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage})
